import ShareJobsForm from '@/apps/share_jobs/ShareJobsForm.vue';
import { requireFamilyConcierge } from '../guards/authGuards';

const shareJobsRoutes = [
  {
    path: '/share-jobs',
    name: 'share-jobs',
    component: ShareJobsForm,
    beforeEnter: requireFamilyConcierge,
  },
];

export default shareJobsRoutes;
